import {Injectable} from '@angular/core';
import {
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireOttPlaylist} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class OttPlaylistService {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireOttPlaylist[]>> {
    return this.http
      .get('/ott/playlists', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttPlaylist>> {
    return this.http
      .get(`/ott/playlists/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/ott/playlists/${id}`, {params: objectToHttpParams(params)});
  }

  create(
    body: Partial<UmpireOttPlaylist>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttPlaylist>> {
    return this.http
      .post('/ott/playlists', serialize({stuff: body}), {params})
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireOttPlaylist>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttPlaylist>> {
    return this.http
      .patch(`/ott/playlists/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
